<template>
  <div id="PCNotePartPreventForgettingToSave" class="popup-wrapper" @click.self="close">
    <div class="popup-container md center">
      <div class="button close">
        <span role="button" class="btn" @click="close">
          <FontawesomeIcon :icon="['fal','times']" size="lg" class="icn" />
        </span>
      </div>
      <div class="popup">
        <div class="popup-title">
          <span class="hdg02">ノートの編集の保存</span>
        </div>
        <div class="popup-content">
          <p class="txt">
            ページを移動する前にノートを保存してもよろしいですか？
          </p>
          <div class="ta-center mt20">
            <div class="button inline"
              @click="move"
              >
              <span role="button" class="btn">保存しないで移動</span>
            </div>
            <div class="button inline"
              @click="saveAndMove"
              >
              <span role="button" class="btn">保存して移動</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, reactive, ref, computed } from '@vue/composition-api'

export default defineComponent({
  name: 'PCNotePartPreventForgettingToSave',
  setup (props, context) {

    const close = () => {
      context.emit('close')
    }

    const move = () => {
      context.emit('move')
    }

    const saveAndMove = () => {
      // 保存時
      context.emit('saveAndMove')
    }

    return {
      close,
      move,
      saveAndMove
    }
  }
})
</script>

<style lang="scss" scoped>
  .popup-content .button {
    display: inline-block;
    width: 267px;
    margin-right: auto;
    margin-left: auto;
    & + .button {
      margin-left: 20px;
    }
  }
</style>
